import { render } from "./index.vue?vue&type=template&id=72280d47&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=72280d47&lang=less&scoped=true"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/ypin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72280d47"]])

export default __exports__